import { fetchWrapperPublic } from "helpers/fetch-wrapper";
import { API_BASE_URL } from "helpers/constants";

export class OrderQueries {
    static async getOrders(): Promise<Response> {
        return await fetchWrapperPublic.get(`${API_BASE_URL}/data/order/`);
    }

    static async markAsDelivered(orderId: string): Promise<Response> {
        return await fetchWrapperPublic.patch(`${API_BASE_URL}/data/order/${orderId}/delivered`);
    }
}